export default "__VITE_ASSET__RzBYCPmX__"